import { ReactText, useReducer } from 'react'
import * as React from 'react'
import { ReactNodeViewPortalsContext, PortalsState } from './ReactnodeViewPortalsContext'

interface Props {}

const initialState = {}

export const ReactNodeViewPortalsProvider: React.FC<React.PropsWithChildren<Props>> = ({ children }) => {
  const [data, dispatch] = useReducer(reducer, initialState)

  return (
    <ReactNodeViewPortalsContext.Provider
      value={{
        createPortal: (portal: any) => {
          return dispatch({ type: 'createPortal', key: portal.key, portal })
        },
        removePortal: (key: string) => {
          return dispatch({ type: 'removePortal', key })
        },
        state: data,
      }}
    >
      {children}
      {Object.values(data).map((obj) => obj.portal)}
    </ReactNodeViewPortalsContext.Provider>
  )
}

type CreateAction = {
  type: 'createPortal'
  key: ReactText
  portal: React.ReactPortal
}

type RemoveAction = {
  type: 'removePortal'
  key: ReactText
}

const reducer = (state: PortalsState, action: CreateAction | RemoveAction) => {
  switch (action.type) {
    case 'createPortal':
      return {
        ...state,
        [action.key]: {
          portal: action.portal,
        },
      }
    case 'removePortal':
      const copiedState = { ...state }
      if (copiedState[action.key]) delete copiedState[action.key]
      return copiedState
    default:
      return state
  }
}
